import { Injectable } from '@angular/core';

interface Attribution {
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  utm_content: string;
  utm_term: string;
  landing_page: string;
  timestamp: number;
}

export interface AttributionData {
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  utm_content: string;
  utm_term: string;
  landing_page: string;
}

const STORAGE_KEY = 'beetrack_attribution';
const EXPIRY_MS = 180 * 24 * 60 * 60 * 1000;

@Injectable({ providedIn: 'root' })
export class AttributionService {
  constructor() {
    this.init();
  }

  private init(): void {
    if (this.loadFromStorage()) return;

    const params = new URLSearchParams(window.location.search);
    const utm_source = params.get('utm_source') || '';
    const utm_medium = params.get('utm_medium') || '';
    const utm_campaign = params.get('utm_campaign') || '';
    const utm_content = params.get('utm_content') || '';
    const utm_term = params.get('utm_term') || '';

    const hasUtm = !!(utm_source || utm_medium || utm_campaign || utm_content || utm_term);

    let source = utm_source;
    let medium = utm_medium;

    if (!hasUtm) {
      const referrer = document.referrer;
      if (!referrer) {
        source = 'direto';
      } else {
        try {
          const refHost = new URL(referrer).hostname;
          if (refHost.includes('beetrack.com.br')) {
            source = 'direto';
          } else {
            source = 'organico';
            medium = refHost.replace(/^www\./, '');
          }
        } catch {
          source = 'direto';
        }
      }
    }

    const attribution: Attribution = {
      utm_source: source,
      utm_medium: medium,
      utm_campaign,
      utm_content,
      utm_term,
      landing_page: window.location.href,
      timestamp: Date.now()
    };

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
    } catch {}
  }

  private loadFromStorage(): Attribution | null {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const data = JSON.parse(raw) as Attribution;
      if (Date.now() - data.timestamp >= EXPIRY_MS) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return data;
    } catch {
      return null;
    }
  }

  getAttribution(): AttributionData {
    const data = this.loadFromStorage();
    return {
      utm_source: data?.utm_source ?? '',
      utm_medium: data?.utm_medium ?? '',
      utm_campaign: data?.utm_campaign ?? '',
      utm_content: data?.utm_content ?? '',
      utm_term: data?.utm_term ?? '',
      landing_page: data?.landing_page ?? ''
    };
  }
}
